import {PARAM_LANGUAGE} from '../constants';
import {createActionCreator} from 'PyzShopUi/scripts/shop-ui/includes/enhanced-reducer';

export interface ISetLanguagePayload {
    [PARAM_LANGUAGE]: string;
}

const SET_LANGUAGE = 'SET_LANGUAGE';

export const setLanguage = createActionCreator<ISetLanguagePayload>(SET_LANGUAGE);
